import { useEffect, useState } from 'react';
import { subscribeAnalyticsConsent } from 'lib/firebase/ga_analytics';
import { isAnalyticsConsented } from 'lib/firebase/utils';

const useIsConsented = () => {
  const [isConsented, setIsConsented] = useState(isAnalyticsConsented());

  useEffect(() => {
    const unsubscribe = subscribeAnalyticsConsent(consented => {
      setIsConsented(consented);
    });

    return unsubscribe;
  }, []);

  return isConsented;
};

export default useIsConsented;
